// extracted by mini-css-extract-plugin
export var component = "ContentNodeTeaser-module--component--68+7e";
export var excerpt = "ContentNodeTeaser-module--excerpt--JYTkD";